// =============================================================================
// features/sales/components/NextActionBadge.tsx — Badge de "próxima ação" de
// um compromisso da agenda comercial, componente do módulo (doc 26 §7).
//
// Urgência nunca só por cor (doc 26 §7) — reusa `nextActionLabel` (texto
// legível: canal + quando) e `urgencyLevel`/`URGENCY_BADGE_VARIANT`
// (F33-S05) como ÚNICA fonte da cor/rótulo, para não divergir do
// `AppointmentCard` da lista.
// =============================================================================

import type { Appointment } from '@elemento/shared-schemas';
import * as React from 'react';

import { Badge } from '../../../components/ui/Badge';
import { URGENCY_BADGE_VARIANT, nextActionLabel, urgencyLevel } from '../agenda/labels';

export interface NextActionBadgeProps {
  appointment: Appointment;
  now: Date;
  className?: string | undefined;
}

/**
 * Badge com a próxima ação do compromisso ("Ligação — em 25 min",
 * "WhatsApp — atrasado há 40 min"...). Reutilizável fora da agenda — ex.
 * card "Próxima ação" do detalhe do lead (doc 26 §6.3, F33-S07).
 */
export function NextActionBadge({
  appointment,
  now,
  className,
}: NextActionBadgeProps): React.JSX.Element {
  const urgency = urgencyLevel(appointment, now);
  return (
    <Badge variant={URGENCY_BADGE_VARIANT[urgency]} {...(className ? { className } : {})}>
      {nextActionLabel(appointment, now)}
    </Badge>
  );
}
